"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: "orderRecommended",
      searchQuery: {
        startDay: '',
        endDay: '',
        empNo: '',
        empName: ''
      },
      apiModule: "kpiSet",
      urlModule: "REPORT"
    };
  },
  computed: {
    domData: function domData() {
      return {
        startDay: {
          label: this.$t("sfe.orderRecommended.select.startDay"),
          valueKey: "startDay",
          inputType: "date",
          type: "date",
          valueFormat: 'yyyyMMdd'
        },
        endDay: {
          label: this.$t("sfe.orderRecommended.select.endDay"),
          valueKey: "endDay",
          inputType: "date",
          type: "date",
          valueFormat: 'yyyyMMdd'
        },
        empNo: {
          label: this.$t("sfe.orderRecommended.select.empNo"),
          valueKey: 'empNo'
        },
        empName: {
          label: this.$t("sfe.orderRecommended.select.empName"),
          valueKey: 'empName'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t("sfe.route.orderrecommended"),
          apiUrl: "/protected/pc/report/srOrderRecommendDetail/export"
        }
      };
    },
    tableDom: function tableDom() {
      return {
        srEmpNo: {
          label: this.$t("sfe.orderRecommended.table.srEmpNo")
        },
        srEmpName: {
          label: this.$t("sfe.orderRecommended.table.srEmpName")
        },
        recommendStoreFrequency: {
          label: this.$t("sfe.orderRecommended.table.recommendStoreFrequency")
        },
        recommendStoreQty: {
          label: this.$t("sfe.orderRecommended.table.recommendStoreQty")
        },
        recommendSizeAddQty: {
          label: this.$t("sfe.orderRecommended.table.recommendSizeAddQty")
        },
        recommendSizeRemoveQty: {
          label: this.$t("sfe.orderRecommended.table.recommendSizeRemoveQty")
        },
        recommendTireQty: {
          label: this.$t("sfe.orderRecommended.table.recommendTireQty")
        },
        viewStoreAddQty: {
          label: this.$t("sfe.orderRecommended.table.viewStoreAddQty")
        },
        viewStoreRemoveQty: {
          label: this.$t("sfe.orderRecommended.table.viewStoreRemoveQty")
        },
        purchaseStoreAddQty: {
          label: this.$t("sfe.orderRecommended.table.purchaseStoreAddQty")
        },
        purchaseStoreRemoveQty: {
          label: this.$t("sfe.orderRecommended.table.purchaseStoreRemoveQty")
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: "/protected/pc/report/srOrderRecommendDetail/list"
      };
    }
  },
  methods: {}
};